import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRouter } from "vue-router";
import AppShell, { type ShellRoute } from "@/components/layout/AppShell.vue";
import { useAuthService } from "@/services/authService";
import { useAuthStore } from "@/store/AuthStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerMainViewWithAppBar',
  setup(__props) {

const router = useRouter();
const { logout: authLogout } = useAuthService();
const authStore = useAuthStore();
const fullName = computed(() => authStore.fullName);

const mainRoutes = computed<ShellRoute[]>(() => {
  const routes: ShellRoute[] = [
    { path: "/", name: "Kezdőlap", icon: "mdi-view-dashboard-outline" },
    {
      path: "/accommodationinquiries",
      name: "Szállás igények",
      icon: "mdi-message-text-outline",
    },
    {
      path: "/bookings",
      name: "Foglalások",
      icon: "mdi-calendar-check-outline",
    },
    {
      path: "/costcenters",
      name: "Költséghelyek",
      icon: "mdi-office-building-outline",
    },
  ];
  if (authStore.isCompanyAdmin) {
    routes.push({
      path: "/users",
      name: "Felhasználók",
      icon: "mdi-account-multiple-outline",
    });
  }
  return routes;
});

async function logout() {
  await authLogout();
  router.push("/login");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppShell, {
    routes: mainRoutes.value,
    "home-path": "/",
    "full-name": fullName.value,
    onLogout: logout
  }, null, 8, ["routes", "full-name"]))
}
}

})